import { api } from "../api";
import { PaginationOptions, PaginatedResponse } from "@/types/Pagination";
import { withoutActorIdentity } from "./actorIdentity";
import { getErrorResponse } from "../errorHandler";

export const listMyPedigrees = async (
  options: PaginationOptions,
  params: object,
): Promise<PaginatedResponse<object>> => {  
  const { page, itemsPerPage, sortBy, sortDesc } = options;

  const sort = !!sortBy?.length ? sortBy[0] : 'id';
  const asce = !!sortDesc?.length ? !sortDesc[0] : false;

  const { data } = await api.get<PaginatedResponse<object>>(`/pedigree/pedigrees`, {
    params: { ...params, pageSize: itemsPerPage, page, ascending: asce, sort }
  });

  return data;
};

export const orderPedigree = async (dto: any): Promise<any> => {
  try {
    const { data } = await api.post<any>('/pedigree/order', withoutActorIdentity(dto));
    return { ...data };
  }  catch (err) {
      const response = getErrorResponse(err);
      if (response?.data) {
        return {...response.data, success: false};
      } else {
        return { errors: ["An Unknown Error Occured"], success: false };
      }
  }
}

export const getFees = async (): Promise<any> => {
  try {
    const { data } = await api.get<any>(`/pedigree/fees`);
    return {...data, success: true};
  }  catch (err) {
      const response = getErrorResponse(err);
      if (response?.data) {
        return {...response.data, success: false};
      } else {
        return { errors: ["An Unknown Error Occured"], success: false };
      }
  }
}

export default {
  listMyPedigrees,
  orderPedigree,
  getFees,
};
